<template lang="pug">
.form-set.center(:class="{'inside-padding': !fillData}")
  form(@submit.prevent="" autocomplete="off")
    h2.title {{ title }}
      .input-container
        input.input(v-model.number="dataForm.order" type="number" autocomplete="ño" required)
        label.label(:class="{ show: dataForm.order }")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="order" title="Orden")

      .input-container.arrow
        select.select(v-model="dataForm.brand" autocomplete="ño" :disabled="fillData" required)
          option(value="")
          option(v-for="brand in brands" :value="brand") {{ capitalize(brand) }}
        label.label(:class="{ show: dataForm.brand }") Marca

    .form-section
      h2.title Imagen
      TransitionGroup.images-product-container(name="slide-fade")
        .image(v-for="(image, index) in dataForm.images" :key="image")
          div {{ image }}
          img(:src="`${imagePath}/${dataForm.brand}/products/sets/${image}`")

    .divider

    .form-section
      shUploadImage(v-if="dataForm.brand" :brand="dataForm.brand" person="sets" @uploaded="addImage" title="Subir Imagen Set" :multiple="false")

    .divider

    .form-section
      h2.title Productos

    .center
      TransitionGroup.products-set(name="slide-fade")
        div(v-for="(product, index) in products" :key="product.product")
          div {{ product.product }}
          img.image(:src="`https://sahet-cdn.b-cdn.net/img/${product.brand}/products/${product.person}/${product.product}.jpg`")
          .buttons-image
            shActionButton(v-if="index" :action="toLeft" :params="[index, true]" text="<" textRunning="<" :mini="true")
            shActionButton(v-if="dataForm.products.length - 1 !== index" :action="toRight" :params="[index, true]" text=">" textRunning=">" :mini="true")
            shActionButton(:action="deleteImage" :params="[index, true]" text="x" textRunning="x" :mini="true" :warning="true")

    .form-section
      .input-container
        input.input(v-model="search" autocomplete="ño" @keypress.enter.prevent="findProduct")
        label.label(:class="{ show: search }") Buscar Producto

      .center
        shActionButton(text="Buscar" textRunning="Buscando" :action="findProduct")

    .checkbox-section
      .input-container-checkbox
        label.label-checkbox(:for="`active${dataForm.id}`")
          shProperty(:dataOriginal="dataOriginal" :dataForm="dataForm" property="active" title="Activo")
          input.input-checkbox(v-model="dataForm.active" :id="`active${dataForm.id}`" type="checkbox")
          .checkmark

    shActionButton(:isForm="true" :text="fillData ? 'Actualizar' : 'Guardar'" :textRunning="fillData ? 'Actualizando' : 'Guardando'" :action="sendForm")

  .right(v-if="fillData")
    shDeleteButton(@delete="deleteSet")
</template>

<script>
import mDB from '@/mixins/db'
import mForm from '@/mixins/form'
import mFilters from '@/mixins/filters'
import gqlSet from '@/graphql/set'
import gqlProduct from '@/graphql/product'
import shDeleteButton from '@/components/elements/DeleteButton'
import shProperty from '@/components/elements/Property'
import shUploadImage from '@/components/pages/image/FormUpload'
import shInputList from '@/components/elements/InputList'
import gql from '@my/graphql'
import modals from '@my/store/modals'

export default {
  name: 'FormSet',

  mixins: [mDB, mForm, mFilters],

  components: { shDeleteButton, shProperty, shUploadImage, shInputList },

  props: {
    title: String,
    fillData: Boolean,
    dataOriginal: Object
  },

  data () {
    return {
      dataForm: {
        order: '',
        images: [],
        brand: '',
        active: false,
        products: []
      },
      resolver: 'set',
      key: 'id',
      gql: gqlSet,
      gqlProduct: gqlProduct,
      delete: ['id'],
      products: [],
      search: ''
    }
  },

  created () {
    if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
  },

  async mounted () {
    if (this.dataForm.products) {
      const data = JSON.parse(JSON.stringify(this.dataForm.products))
      this.dataForm.products = []

      for (let i = 0; i < data.length; i++) {
        const name = data[i]

        this.search = name
        await this.findProduct()
      }

      this.search = ''
    }
  },

  methods: {
    sendForm () {
      if (!this.fillData) {
        this.newSet()
        this.products = []
        this.dataForm.products = []
        this.dataForm.images = []
      } else {
        this.updateSet()
      }
    },

    newSet () {
      this.newData(this.gql, this.resolver, this.key)
    },

    updateSet () {
      this.updateData(this.gql, this.resolver, this.key)
    },

    deleteSet () {
      this.deleteData(this.gql, this.resolver, this.key)
    },

    addImage (name) {
      this.dataForm.images = []
      /* const index = array.findIndex(imageName => imageName === name)
      if (index >= 0) array.splice(index, 1) */

      this.dataForm.images.push(name)
    },

    async findProduct () {
      if (!this.search) return

      const mutation = gqlProduct.GET_BY_PRODUCT

      const response = await gql.mutate(mutation, { product: this.search.toLowerCase() }, false)

      if (response.error) {
        modals.showMessage({ message: `El producto '${this.search}' no se encontró`, type: 'error' })
      } else {
        const product = response.data.getByProduct
        this.addProduct(product)
      }
    },

    addProduct (product) {
      const array = this.products
      const arrayData = this.dataForm.products

      const index = array.findIndex(element => element.product === product.product)
      if (index >= 0) {
        array.splice(index, 1)
        arrayData.splice(index, 1)
      }

      array.push(product)
      arrayData.push(product.product)
    },

    toLeft (index, isMeasure) {
      if (!index) return

      const array = this.products
      const arrayData = this.dataForm.products

      const product = array[index]
      const productName = arrayData[index]

      array.splice(index, 1)
      arrayData.splice(index, 1)
      array.splice(index - 1, 0, product)
      arrayData.splice(index - 1, 0, productName)
    },

    toRight (index) {
      const array = this.products
      const arrayData = this.dataForm.products
      if ((array.length - 1) === index) return

      const product = array[index]
      const productName = arrayData[index]
      array.splice(index, 1)
      arrayData.splice(index, 1)
      array.splice(index + 1, 0, product)
      arrayData.splice(index + 1, 0, productName)
    },

    deleteImage (index) {
      const array = this.products
      const arrayData = this.dataForm.products
      array.splice(index, 1)
      arrayData.splice(index, 1)
    }
  },

  computed: {
    brands () {
      return this.$store.state.variables.brands
    }
  },

  watch: {
    dataOriginal: {
      handler (val) {
        if (this.fillData) this.dataForm = this.copyObject(this.dataOriginal)
      },
      deep: true
    }
  }
}
</script>

<style lang="stylus">
.form-set
  position relative

.image > img
  width 20%
  min-width 300px

.products-set
  display inline-flex
  flex-wrap wrap
  gap 1em
  justify-content center

.products-set > div
  flex-basis 20%
  width 20%
  min-width 300px

.products-set img
  width 100%

.buttons-image
  display flex
  gap 1em
  justify-content center
</style>



// WEBPACK FOOTER //
// src/components/pages/set/Form.vue